module.exports = __webpack_public_path__ + "static/media/yolo.c78527cc.png";